import PropTypes from 'react-proptypes';
import styled from '@emotion/styled';
import PercentageSvg from 'images/shared/percent.svg';

const EmptyMessage = styled.div(({theme}) => ({
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  color: theme.primaryFontColor,
  fontSize: '24px',
  lineHeight: '32px',
  margin: '16px 8px 48px',
  span: {
    maxWidth: 400,
    textAlign: 'center',
  },
  svg: {
    fill: theme.primaryFontColor,
    width: '30px',
    height: '30px',
    marginBottom: '16px',
  },
}));

const NoRatesMessage = ({ message, ...props }) => (
  <EmptyMessage {...props}>
    <PercentageSvg />
    <span>{message}</span>
  </EmptyMessage>
);

NoRatesMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

NoRatesMessage.defaultProps = {
  message: 'Er zijn geen rentes gevonden met de door u ingevulde waardes',
}

export default NoRatesMessage;
